/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { parseDate } from "@lyfegen-platform/utils";
import { addDays, isAfter } from "date-fns";
import { useFieldValue } from "formik";
import * as Yup from "yup";
import { getFormDatesByCases } from "../hooks/useSiblingFormDates";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { getMinAssessmentDate, getMinDateMessage } from "../utils/get-min-assessment-date";
import { renderRequiredMessage } from "../utils/render-required-message";
import { TrFun } from "../utils/types";
import { GeneralFieldController } from "./general-field-controller";

export class PrescriptionDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translate: TrFun): Yup.AnySchema {
		const dates = getFormDatesByCases(this.parent.context.cases, this.parent.context.flexEntity?.createdOn);

		return (this.createFieldValidationRuleByDataType(translate) as Yup.DateSchema)
			.max(new Date(), translate("cannot-be-greater-than-today"))
			.min(
				parseDate(
					getMinAssessmentDate(null, dates.responseAssessmentDate, dates.startingFormAssessmentDate, dates.maxPrescriptionDate)
				),
				getMinDateMessage(
					translate,
					null,
					dates.responseAssessmentDate,
					dates.startingFormAssessmentDate,
					dates.maxPrescriptionDate
				)
			)
			.required(() => renderRequiredMessage(this.schema.attribute.identifier, translate))
			.when("$values", (values: any, schema: Yup.DateSchema) =>
				schema.test(
					"isBeforeAssessmentDate",
					translate("cannot-be-after-assessment-date"),
					(v) => !v || !isAfter(parseDate(v) as Date, parseDate(values[AttributeIdentifiers.BenefitAssessmentDate]))
				)
			);
	}

	override useControlProps(): FlexControlProps {
		const [assessmentDate] = useFieldValue(AttributeIdentifiers.BenefitAssessmentDate);
		const dates = getFormDatesByCases(this.parent.context.cases, this.parent.context.flexEntity?.createdOn);
		const minPrescriptionDate = addDays(
			parseDate(
				getMinAssessmentDate(null, dates.responseAssessmentDate, dates.startingFormAssessmentDate, dates.maxPrescriptionDate)
			) as Date,
			1
		);

		return {
			maxDate: assessmentDate,
			minDate: minPrescriptionDate,
		};
	}
}
